"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IcLinePageNew = (props) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.35 9.55V4H10.55V9.55H16V10.75H10.55V16H9.35V10.75H4V9.55H9.35Z" }) })));
exports.default = IcLinePageNew;
